import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APP_NAME } from '@monorepo/utils';

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected title = APP_NAME;
}
